import { LicenceRoleType } from '@enums/licence-role-type.enum';
import { LinkDisplayType } from '@enums/link-display-type.enum';
import { ProviderType } from '@enums/provider-type.enum';

export class NavLink {
    icon: string;
    title?: string;
    linkLabel?: string;
    content?: string;

    route?: string;
    url?: string;

    isDisabled?: boolean;
    isMobileHidden?: boolean;
    display: LinkDisplayType;

    roles?: LicenceRoleType[];
    providers?: ProviderType[];
    children?: NavLink[];

    constructor(route: string, title: string, icon: string) {
        this.route = route;
        this.icon = icon;

        this.title = title + '.shortLabel';
        this.linkLabel = title + '.fullLabel';
        this.content = title + '.summary';
    }
}
